import { includesNormalizedCaseInsensitive } from '@/utils/string';

const knownVideoPlatforms = new Set(['youtube.com', 'youtu.be', 'twitch.tv', 'vimeo.com']);

export function isValidVideoLink(
  /** @type {string | URL} */
  url,
) {
  if (!url) return false;
  try {
    const { hostname } = new URL(url);
    // check common video file extensions
    // NOTE: Disabled since we only accept known platforms atm, video files are irrelevant
    // if (/\.(mp4|webm|ogg|mov)(\?.*)?$/i.test(pathname)) {
    //   return true;
    // }
    // check known platforms
    // eslint-disable-next-line sonarjs/prefer-single-boolean-return -- May add back other checks
    if (knownVideoPlatforms.has(hostname.replace('www.', ''))) {
      return true;
    }

    return false;
  } catch {
    // TypeError if invalid URL
    return false;
  }
}

export function caseInsensitiveFilterOnAllStringProps(array, searchText) {
  if (!searchText) return array;

  return array.filter(item =>
    Object.values(item).some(
      value =>
        typeof value === 'string'
        && includesNormalizedCaseInsensitive(value, searchText, { accents: true, casing: true }),
    ),
  );
}

/**
 * Whether a raw text input is acceptable so far as a money amount:
 * digits only, with at most 2 decimals. Our money columns are
 * `DecimalField(decimal_places=2)`, and PayPal caps amounts at 10 characters.
 * Partial input is allowed (`""`, `"4"`, `"4."`) so the field stays typeable.
 * @param {string} value
 */
export const isPartialMoneyAmount = value => /^\d*(?:\.\d{0,2})?$/.test(value);

/**
 * @param {number} value
 * @param {string | null | undefined} [language]
 * @param {boolean} [displayIsoCode]
 */
export const formatCurrency = (value, language, displayIsoCode = false) => {
  language ||= 'en';
  const formattedNumber = value.toLocaleString(language, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const currencyCode = displayIsoCode ? ' CAD' : '';

  return (language === 'en' ? `$${formattedNumber}` : `${formattedNumber} $`) + currencyCode;
};
